// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"764cbea4","911":"2648e5df","2309":"e2debcd1","2637":"27eec2d4","2768":"802b2648","4774":"d1fa497b","4941":"1a46705c","8533":"a07e5131","8803":"7f64d73e"}[chunkId] + ".chunk.css";
};